import { AxiosResponse } from 'axios';
import { TourData, TourProductQuotationData } from '../types/TourData';
import { API_TOURS } from '../utils/urls';
import { axios, get, post, put } from './baseAxios';

const url = API_TOURS;

export const getTour = (id) => get(`${url}/${id}`);

export const getTours = (request) => get(url, request);

export const updateTour = (id, request) => put(`${url}/${id}`, request);

export const createTour = (request) => post(url, request);

export const deleteTour = (id) => axios.delete(`${url}/${id}`);

export const getTourByCode = (code) => get(`${url}/${code}/visualize`);

export const saveConfigTour = (id, request) => put(`${url}/${id}/config`, request);

export const makeTour = (request) => post(`${url}/make`, request);

export const updateTourGuides = (id, request) => put(`${url}/${id}/tourGuides`, request);

export const createTourCategory = (id, request) => put(`${url}/${id}/tourCategories`, request);

export const createSceneGroup = (id, request) => put(`${url}/${id}/scene-groups`, request);

export const saveTourContacts = (tourId, request) => put(`${url}/${tourId}/contacts`, request);

export const getTourByAlias = (alias: string) => get(`/v1/ext/tours/${alias}`);

export const updateTourScenes = (id, request) => put(`${url}/${id}/tourScenes`, request);

export const updateTourBackgroundSound = (id, request) =>
  put(`${url}/${id}/backgroundSound`, request);

export const updateTourMask = (id, request) => put(`${url}/${id}/mask`, request);

export const updateTourSetting = (id, request) => put(`${url}/${id}/setting`, request);

export const cloneTour = (id, request = {}): Promise<AxiosResponse<TourData>> =>
  post(`${url}/${id}/clone`, request);

export const updateTourScenario = (id, request) => put(`${url}/${id}/tour-scenarios`, request);

export const updateBlendMode = (id, request) => put(`${url}/${id}/scene-blend-mode`, request);

export const updateTourSceneName = (id, request) => put(`${url}/${id}/scene-name`, request);

export const publishTour = (request: TourData) => post(`${url}/published`, request);

export const enableTourScenario = (id, tourScenarioId, enabled) =>
  post(`${url}/${id}/tour-scenarios/${tourScenarioId}/enabled?enabled=${enabled}`);

export const updateDefaultTourScenario = (id, tourScenarioId, isDefault) =>
  post(`${url}/${id}/tour-scenarios/${tourScenarioId}/update-default?isDefault=${isDefault}`);

export const cloneTourScenario = (id, request = {}): Promise<AxiosResponse<TourData>> =>
  post(`${url}/${id}/tour-scenarios/clone`, request);

export const updateHotspotsAGTConfig = (id, request) =>
  put(`${url}/${id}/hotspots-agt-config`, request);

export const updateProductQuotations = (
  id,
  request = {}
): Promise<AxiosResponse<TourProductQuotationData[]>> =>
  put(`${url}/${id}/product-quotations`, request);

export const createTourFunctionButton = (id, request) =>
  put(`${url}/${id}/tour-function-buttons`, request);

export const updateConfigLanguages = (request) =>
  put(`${url}/${request.id}/config-languages`, request);

export const mergeTour = (request) => post(`${url}/merge-tour`, request);
